import { css, palette } from 'bumbag';
import { _ as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var Table = {
  styles: {
    base: function base(props) {
      return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      color: ", ";\n    "])), palette('text200')(props));
    }
  },
  Head: {
    styles: {
      base: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n        background-color: rgba(0, 0, 0, 0.05);\n      "])))
    }
  },
  Cell: {
    styles: {
      base: css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n        padding: 1rem;\n        vertical-align: middle;\n      "])))
    }
  },
  HeadCell: {
    styles: {
      base: function base(props) {
        return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n        color: ", ";\n        font-size: 12px;\n        line-height: 2;\n        margin-bottom: 0px;\n        text-transform: uppercase;\n      "])), palette('text100')(props));
      }
    }
  }
};

export default Table;
